import {Injectable} from '@angular/core';
import { Device } from 'src/app/modals/device';
import { plainToClass } from 'class-transformer';
import { User } from 'src/app/modals/user';
// import {SettingService} from './setting-service';



@Injectable({
  providedIn: 'root'
})
export class ApiEndpoints {

  constructor() {}

  get BASE_API_URL(): string {
    //return  'http://127.0.0.1:8000/';
    return 'https://app.optimumdigital.academy/';
  }


  get URL_GET_LOADING(): string {
    return this.BASE_API_URL + 'frontend/api/dataloading';
  }

  get URL_GET_SEARCH(): string {
    return this.BASE_API_URL + 'frontend/api/search/produits';
  }



  /************************* PRODUIT ********************************/
  URL_GET_PRODUITS_SELLER(idVendeur: number): string {
    return this.BASE_API_URL + 'api/produits?vendeur=' + idVendeur;
  }

  URL_GET_SOUSCRIPTIONS_USERS(iduser: number): string {
    return this.BASE_API_URL + 'api/souscription/user/' + iduser;
  }

  get URL_GET_PRODUITS(): string {
    return this.BASE_API_URL + 'frontend/api/produits';
  }


  GET_URL_ONE_PRODUIT(id: number): string {
    return this.BASE_API_URL + 'frontend/api/produits/' + id;
  }

  GET_URL_PUT_PRODUIT(id: number): string {
    return this.BASE_API_URL + 'frontend/api/produits/' + id;
  }

  GET_URL_PUT_PRODUIT_BY_SELLER(id: number): string {
    return this.BASE_API_URL + 'api/produits/' + id;
  }

  get GET_URL_POST_PRODUIT(): string {
    return this.BASE_API_URL + 'api/produits';
  }

  GET_URL_DELETE_PRODUIT(id: number): string {
    return this.BASE_API_URL + 'api/produits/' + id;
  }

  URL_PRODUIT_ADD_IMAGE(idprod: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/addimage'
  }

  URL_PRODUIT_REMOVE_IMAGE(idprod: number, image: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/removeimage?image=' + image;
  }

  URL_PRODUIT_ADD_FICHIER(idprod: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/addfichier'
  }

  URL_PRODUIT_ADD_OTHER_FICHIER(idprod: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/addotherfile'
  }

  URL_PRODUIT_RENAME_OTHER_FICHIER(idfichier: number): string {
    return this.BASE_API_URL + 'api/fichiers/' + idfichier
  }

  URL_PRODUIT_REMOVE_FICHIER(idprod: number, fichier: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/removefichier?fichier=' + fichier;
  }

  URL_PRODUIT_REMOVE_OTHER_FICHIER(idprod: number, fichier: number): string {
    return this.BASE_API_URL + 'api/produits/' + idprod + '/removeotherfichier?fichier=' + fichier;
  }

  /************************* PRODUIT ********************************/


  /************************* PRODUIT ********************************/
  URL_GET_TRANSACTIONS(iduser: number, numpage): string {
    return this.BASE_API_URL + 'api/caisse/flux?patner=' + iduser + '&cashstate=undefined&nature=caisse' + '&page=' + numpage;
    // http://app.bessalel.net/api/caisse/flux?from=2022-06-21&to=2022-06-21&patner=5140&cashstate=undefined&nature=caisse
  }

  URL_GET_GAINS(iduser: number): string {
    return this.BASE_API_URL + 'api/getgains?iduser=' + iduser;
    // http://app.bessalel.net/api/caisse/flux?from=2022-06-21&to=2022-06-21&patner=5140&cashstate=undefined&nature=caisse
  }

  /************************* CATEGORIE ********************************/
  get URL_GET_CATEGORIES(): string {
    return this.BASE_API_URL + 'frontend/api/catproduits';
  }
  /************************* CATEGORIE ********************************/




  /************************* LOGIN ********************************/
  get GET_URL_LOGIN(): string {
    if(this.getDevice !== undefined)
    return this.BASE_API_URL + 'api/login?space=frontend&device=' + this.getDevice.id;
    else
    return this.BASE_API_URL + 'api/login?space=frontend';
  }
  /************************* LOGIN ********************************/

  /************************* LOGIN ********************************/
  GET_URL_SOCIALLOGIN(name: string, email: string): string {
    if(this.getDevice !== undefined)
    return this.BASE_API_URL + 'api/sociallogin?space=frontend&device=' + this.getDevice.id + '&name=' + name + '&email=' + email;
    else
    return this.BASE_API_URL + 'api/sociallogin?space=frontend' + '&name=' + name + '&email=' + email;
  }
  /************************* LOGIN ********************************/



  /************************* USER ********************************/

  GET_URL_POST_USERS(): string {
    let parrain = localStorage.getItem('parrain');
    if(this.getDevice !== undefined)
    return this.BASE_API_URL + 'api/users?space=frontend&device=' + this.getDevice.id + '&parrain=' + parrain;
    else
    return this.BASE_API_URL + 'api/users?space=frontend' + '&parrain=' + parrain;
  }

  GET_URL_PATCH_USERS(id: number): string {
    return this.BASE_API_URL + 'api/users/' + id + '?space=frontend';
  }

  GET_URL_GET_USERS(id: number): string {
    return this.BASE_API_URL + 'api/users/' + id ;
  }

  GET_URL_FORGETPASS(email: string): string {
    return this.BASE_API_URL + 'api/forgetpass?email=' + email;
  }

  GET_URL_CHANGEPASS(code: string, newpassword: string): string {
    return this.BASE_API_URL + 'api/changepass?resetToken=' + code + '&newpassword=' + newpassword;
  }

  /************************* USER ********************************/


  /************************* DEVICE ********************************/

  GET_URL_POST_DEVICE(): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    if(this.getUser !== undefined)
    return this.BASE_API_URL + 'frontend/api/devices/?userId=' + this.getUser;
    else
    return this.BASE_API_URL + 'frontend/api/devices';

  }

  GET_URL_PATCH_DEVICE(id: number): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    if(this.getUser !== undefined)
    return this.BASE_API_URL + 'frontend/api/devices/' + id + '?userId=' + this.getUser;
    else
    return this.BASE_API_URL + 'frontend/api/devices/' + id;

  }

  /************************* DEVICE ********************************/




  /************************* FACTURE ********************************/

  GET_URL_POST_FACTUREANDFLUX(modePayment: string, devise: string): string {
    // return this.BASE_API_URL + 'api/facturesflux';
    let url =  this.BASE_API_URL + 'api/facturesflux?paymentmode=' + modePayment;
    
    if(devise !== undefined) {
      url += '&devise=' + devise;
    } else {
      url += '&devise=XAF';
    }

    return url;
    
  }

  URL_GET_FACTURES( datefrom: string, dateto: string, type: string, idpartner: string, paidstatus: string, state: string): string {
    let to = '';
    if (dateto !== '')
    to = '&to=' + dateto;
    else
    to = '&to=';

    let from = '';
    if (datefrom !== '')
    from = '&from=' + datefrom;
    else
    from = '&from=';

    // tslint:disable-next-line:max-line-length
    return this.BASE_API_URL + 'api/factures?type=' + type + from + to  + '&partner=' + idpartner + '&paidstatus=' + paidstatus + '&etat=' + state;
  }

  /************************* FACTURE ********************************/

  get getDevice(): Device {

      const device = JSON.parse(localStorage.getItem('device')) || undefined;

      if( device !== undefined)
      return plainToClass(Device, device as object);
      else
      return undefined;

  }

  get getUser(): User {

    const token = JSON.parse(localStorage.getItem('bessalel_token')) || undefined;

    if( token !== undefined)
    return token.user.id;
    else
    return undefined;

  }


}
